import { getCookie } from './cookies.script'
import { authCompany } from './authentication.script'

export function getChatToken(): string {
  return getCookie('access') || ''
}

export function isChatAllowed(): boolean {
  return authCompany() !== null
}

export function activeCompanyId(): string | null {
  return authCompany()?.id ?? null
}

/**
 * Extract the user id used by the chat service from the JWT access token.
 * Tries several common claim names: the chat service may store the id
 * under `sub`, `id`, `user_id`, `userId`, or `_id`.
 */
export function currentUserId(): string {
  const token = getChatToken()
  if (!token) return ''
  try {
    const payload = JSON.parse(atob(token.split('.')[1]))
    const id = payload.sub ?? payload.id ?? payload.user_id ?? payload.userId ?? payload._id ?? ''
    return String(id)
  } catch {
    return ''
  }
}
